import { render, staticRenderFns } from "./EntrepreneurTitleText.vue?vue&type=template&id=243eaac2&"
import script from "./EntrepreneurTitleText.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurTitleText.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurTitleText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports